<template>
  <div
    class="flex-row flex-grow position-relative h-full"
    data-test="producer-editor"
  >
    <div v-if="!isSocketConnected" class="disconnected-overlay" />

    <div class="layer-editor level-01dp">
      <div class="header panel-drag-handle">
        <div class="flex items-center">
          <span class="title">{{ title }}</span>

        </div>
      </div>

      <template v-if="editing && isEditable">
        <graphic
          v-if="editing.layout == 'graphic'"
          :key="editing.timeline_id"
          :editing="editing"
          :item="editing"
          ref="graphicEditor"
        />

        <panel
          v-else-if="editing.layout == 'panel'"
          :editing="editing"
          :item="panel"
          ref="panelEditor"
        />

        <asset-editor
          v-else-if="editing.layout == 'asset'"
          :item="editing"
          :editing="editing"
        />

        <poll-editor
          v-else-if="editing.layout == 'poll'"
          :item="editing"
          :editing="editing"
        />

        <!-- editing is a dumb name, and it's dumb we have two props referencing it -->
        <theme
          v-else
          :item="editing"
          :editing="editing"
        />

        <div class="footer">
          <portal-target name="editor-footer"></portal-target>
        </div>
      </template>

      <template v-if="!editing || !isEditable">
        <div class="droparea">
          <div class="droparea-help-text">Click on a playlist item to start editing</div>
        </div>
      </template>

      <modal
        v-if="assetModalOpen"
        class="asset-uploader-modal"
        body-style="padding: 0;"
      >
        <template slot="modal-header">
          <div class="title">Choose media</div>
          <button v-on:click="toggleAssetModal(false)" class="modal-close tb-btn tb-btn-text sm low-em"><span class="icon icon-cross"></span></button>
        </template>

        <template slot="modal-body">
          <iframe
            id="asset-uploader"
            :src="assetManagerSrc"
            height="100%"
            width="100%"
            style="width: 100%; height: 100%; border: 0; background: white;"
          />
        </template>
      </modal>

      <portal-target name="new-graphic-modal"></portal-target>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { PortalTarget } from 'portal-vue';
import GraphicEditorComponent from '../graphic-editor/GraphicEditor.vue';
import ThemeEditorComponent from '../theme-editor/ThemeEditor.vue';
import PanelEditorComponent from '../panel-editor/PanelEditor.vue';
import AssetEditor from '../asset-editor/AssetEditor.vue';
import PollEditor from '../poll-editor/PollEditor.vue';
import ModalComponent from '../modal/Modal.vue';

const findNested = (posts, timelineId) => {
  for (let i = 0; i < posts.length; i += 1) {
    const post = posts[i];

    if (post?.timeline_id === timelineId) {
      return post;
    }

    if (post?.posts?.length) {
      const nested = findNested(post.posts, timelineId);

      if (nested) {
        return nested;
      }
    }
  }

  return null;
};

export default {
  name: 'LayerEditor',

  components: {
    PortalTarget,
    modal: ModalComponent,
    graphic: GraphicEditorComponent,
    theme: ThemeEditorComponent,
    panel: PanelEditorComponent,
    AssetEditor,
    PollEditor,
  },

  computed: {
    ...mapState({
      isSocketConnected: state => state.clients.isSocketConnected,
    }),

    title() {
      if (!this.editing || !this.isEditable) {
        return 'Layer Editor';
      }

      if (this.editing.layout === 'graphic') {
        return 'Graphic Editor';
      }

      return 'Display Editor';
    },

    /**
     * Layers like "graphics" don't have anything to edit (atm)
     */
    isEditable() {
      return this.editing?.layout !== 'graphics';
    },

    editing() {
      const posts = this.$store.state.production.production.timeline;
      const { editing } = this.$store.state.timeline;
      return findNested(posts, editing);
    },

    assetModalOpen() {
      return this.$store.state.graphics.assetModalOpen;
    },

    assetManagerSrc() {
      const assetType = this.$store.state.graphics.assetModalOpenType;
      const { owner } = this.$store.state.production.production;
      return `${process.env.TAGLANDIA_URL}/select-asset?owner=${owner}&filetype=${assetType}`;
    },

    panel() {
      return this.editing._id ? this.$store.state.panels.lookupTable[this.editing._id] : this.editing;
    },
  },
  methods: {
    sendUpdate() {
      this.$store.dispatch('updateTimeline');
    },
    toggleAssetModal(bool) {
      this.$store.dispatch('toggleAssetModal', { toggled: bool, type: 'image' });
    },
  },
};
</script>
